<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import ContractTable from "../../components/datatables/ContractTable.vue";

export default {
    page: {
        title: "Active Contracts",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Active Contracts",
            items: [
                {
                text: "Active Contracts",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            customer_contract_info:[],
            loadingDetail:false,
            loadingRoles:true,
            isButtonDisabled:false,
            programList:[],
            date: '',
            key_search:'',
            program_id:'',
            dtKey:0,
        };
    },

    methods: {

        getPrograms(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.programList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
    },

    components: {
        Layout,
        PageHeader,
        ContractTable,
    },

    mounted() {
        this.getPrograms();
    },
    
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Contract List</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <ContractTable :programList="programList" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>